import React from "react";
import ReactDOM from "react-dom/client";

// Fonts are bundled from npm, never linked from a CDN (§14).
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";

import App from "@/App";
import { handleBack } from "@/lib/back";
import { isNative, leaveApp, onBackButton } from "@/platform";
import { sharedFiles } from "@/components/statements/ShareInSheet";
import { shortcutTaps } from "@/lib/shortcuts";
import { onNotificationOpened } from "@/platform/notifications";
import { onFilesShared } from "@/platform/share";
import { installShortcuts, onShortcut } from "@/platform/shortcuts";
import { registerServiceWorker } from "@/platform/update";
import { loadAuthToken } from "@/platform/session";
import "@/styles/index.css";

const render = () =>
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// Android's back button: close what is open, else back a page, else ask and
// leave (lib/back.ts). BrowserRouter follows history.back() through popstate,
// so this needs no router of its own. A no-op in a browser.
onBackButton((canGoBack) =>
  handleBack(window.location.pathname, canGoBack, () => window.history.back(), leaveApp),
);

// A tapped notification in the Android app opens the page it names (M6).
// BrowserRouter follows a pushed history entry once it hears popstate.
onNotificationOpened((path) => {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
});

// Shortcuts and shared PDFs (M7). Registered at boot, before any screen: a
// shortcut or a share can be what started the app. The screens take them
// from the mailbox when they mount (components/NativeBridges.tsx).
void installShortcuts();
onShortcut((id) => shortcutTaps.put(id));
onFilesShared((files) => files.forEach((f) => sharedFiles.put(f)));

// The Android app reads its sign-in token from encrypted storage before the
// first request; a browser has none and renders at once, as it always did.
if (isNative()) void loadAuthToken().finally(render);
else render();

// The offline shell for browsers and the iPhone home-screen app (mobile M5).
// Production web builds only; never inside the Android app.
void registerServiceWorker();
